import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type EventTypeFilter = 'all' | 'invited' | 'public' | 'recurring'

export interface CalendarFiltersState {
  eventTypeFilter: EventTypeFilter
}

const initialState: CalendarFiltersState = {
  eventTypeFilter: 'all',
}

const calendarFiltersSlice = createSlice({
  name: 'calendarFilters',
  initialState,
  reducers: {
    setEventTypeFilter: (state, action: PayloadAction<EventTypeFilter>) => {
      state.eventTypeFilter = action.payload
    },
    resetFilters: (state) => {
      state.eventTypeFilter = 'all'
    },
  },
})

export const { setEventTypeFilter, resetFilters } = calendarFiltersSlice.actions

export default calendarFiltersSlice.reducer
